import { jobsInquiryFormFields } from '@/components/partials/jobs/constants/inquiryFields';
import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import type { JobsSectionField } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';
import type { CurrentUser } from '~/types/graphql';

export const getSalesExperinceConfig = ({ user }: { user: CurrentUser }): JobsSectionField[] => {
  return [
    {
      attrs: {
        label: 'Specific products',
        value: utils.getStringOfValues(user.productTypes),
        attributeName: jobsInquiryFormFields.PRODUCT_TYPES,
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ user }) => utils.isMultiselectFieldHasSelectedOption(user.productTypes),
    },

    {
      attrs: {
        label: 'Types of products sold',
        value: utils.getStringOfValues(user.industries),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ user }) => utils.isMultiselectFieldHasSelectedOption(user.industries),
    },
    {
      attrs: {
        label: 'Size of companies sold for',
        value: utils.getStringOfValues(user.companyStages),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ user }) => utils.isMultiselectFieldHasSelectedOption(user.companyStages),
    },
    {
      attrs: {
        label: 'Sales roles held',
        value: utils.getStringOfValues(user.warRoomSalesRoles),
        attributeName: jobsInquiryFormFields.WAR_ROOM_SALES_ROLES,
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ user }) => utils.isMultiselectFieldHasSelectedOption(user.warRoomSalesRoles),
    },
    {
      attrs: {
        label: 'Stages of companies sold for',
        value: utils.getStringOfValues(user.companySeriesStages),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ user }) => utils.isMultiselectFieldHasSelectedOption(user.companySeriesStages),
    },
    {
      attrs: {
        label: 'Departments sold to',
        value: utils.getStringOfValues(user.departments),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ user }) => utils.isMultiselectFieldHasSelectedOption(user.departments),
    },
  ];
};
